export default {
  name: 'cache',
  cache: 'cache'
};
